/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-conditional-statement */
import { SetterOrUpdater } from "recoil";
import { OrderState } from "../../app/miscellaneous/orderAtom";
import { definitions } from "../../common-fetch/generated/orders-model-api";
import { fetchGetStates } from "../../app/miscellaneous/fetchGetStates";
import { FinishLoading } from "../../common-loader/miscellaneous/finishWithStatus";

export async function setCountryStates(
  order: OrderState,
  setCountryAdministrativeAreas: SetterOrUpdater<
    ReadonlyArray<definitions["IsoCountryResponse"]>
  >,
  finishLoading: FinishLoading<null>
) {
  const shippingAddress =
    order !== "initializing"
      ? order.shippingInformation?.shippingAddress
      : undefined;
  const billingAddress =
    order !== "initializing"
      ? order.paymentInformation?.billingAddress
      : undefined;

  const countryStates: definitions["IsoCountryResponse"][] = [];

  if (shippingAddress?.countryIso) {
    const result = await fetchGetStates(shippingAddress.countryIso);
    if (result.tag === "successful") {
      countryStates.push(result.parsed);
    } else {
      return finishLoading({
        tag: "errors",
        errors: [],
        uuid: "3c8def08-bd11-4a28-b281-f4bddcbe2ead",
      });
    }
  }
  if (billingAddress?.countryIso) {
    const result = await fetchGetStates(billingAddress.countryIso);
    if (result.tag === "successful") {
      countryStates.push(result.parsed);
    } else {
      return finishLoading({
        tag: "errors",
        errors: [],
        uuid: "cf2db60c-090d-4485-80f4-d870783159fe",
      });
    }
  }
  setCountryAdministrativeAreas(countryStates);
  return finishLoading({ tag: "data", data: null });
}
